import { Text } from '../Text'
// import { ExternalLink } from '../../theme'
import { ButtonPrimary } from '../Button'
// import { OutlineCard } from '../Card'
import Column, { AutoColumn } from '../Column'
import { PaddedColumn } from './styleds'
// import { useDarkModeManager } from '../../state/user/hooks'

// import listLight from '../../assets/images/token-list/lists-light.png'
// import listDark from '../../assets/images/token-list/lists-dark.png'

export default function ListIntroduction({ onSelectList }: { onSelectList: () => void }) {
  // const [isDark] = useDarkModeManager()

  return (
    <Column style={{ width: '100%', flex: '1 1' }}>
      <PaddedColumn>
        <AutoColumn $gap="14px">
          {/* /* <img
            style={{ width: '120px', margin: '0 auto' }}
            src={isDark ? listDark : listLight}
            alt="token-list-preview"
          />
          <img
            style={{ width: '100%', borderRadius: '12px' }}
            src="https://cloudflare-ipfs.com/ipfs/QmRf1rAJcZjV3pwKTHfPdJh4RxR8yvRHkdLjZCsmp7T6hA"
            alt="token-list-preview"
          /> */}
          <Text style={{ marginBottom: '8px', textAlign: 'center' }}>
            Select default list or add your own custom lists via IPFS or HTTPS.{' '}
          </Text> 
          <ButtonPrimary onClick={onSelectList} id="list-introduction-choose-a-list">
            Choose a list
          </ButtonPrimary>
        </AutoColumn>
      </PaddedColumn>
    </Column>
  )
}
